const CompanyPendingActionTypeEnum = {
  CREDIT_REQUEST: "CREDIT_REQUEST",
  COMPANY_INVITED: "COMPANY_INVITED",
  COMPANY_REGISTERED: "COMPANY_REGISTERED",
} as const;

export default CompanyPendingActionTypeEnum;
